import { ChevronDown } from "lucide-react";
// ChevronRight + Link: usados solo por el link "Ver todas" (oculto para el lanzamiento).
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { whatsappHref } from "~/config/whatsappSupport";
import { cn } from "~/lib/utils";
import { sfx } from "~/modules/Landing/lib/landingSound";

type FAQItem = { q: string; a: string };

export function FAQPreviewSection() {
  const { t } = useTranslation();
  const items = t("landing.home.faq.items", { returnObjects: true }) as FAQItem[];
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="relative z-10 bg-landing-white px-5 py-20 sm:px-8">
      <div className="mx-auto max-w-[800px]">
        <div className="mb-10 text-center">
          <h2 className="font-display mb-3 text-[clamp(24px,3.5vw,40px)] font-bold leading-[1.1] tracking-tight text-landing-text">
            {t("landing.home.faq.title")}
          </h2>
          {/* "escribinos" prometía un canal de contacto y era un <p> muerto. Va al
              WhatsApp, que es donde el equipo contesta de verdad (mismo número que el
              botón flotante). */}
          <p className="text-[15px] leading-relaxed text-landing-muted">
            {t("landing.home.faq.description")}{" "}
            <a
              href={whatsappHref(t("landing.home.faq.contactWa"))}
              target="_blank"
              rel="noreferrer"
              data-cuelume-hover="tick"
              data-cuelume-press
              className="font-semibold text-landing-red underline decoration-landing-red/30 underline-offset-4 transition-colors hover:decoration-landing-red"
            >
              {t("landing.home.faq.contactCta")}
            </a>
          </p>
        </div>

        <div className="divide-y divide-landing-border border-y border-landing-border">
          {items.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div key={i}>
                <button
                  type="button"
                  onClick={() => {
                    sfx(isOpen ? "droplet" : "bloom");
                    setOpenIdx(isOpen ? null : i);
                  }}
                  className="flex w-full items-center justify-between gap-4 py-5 text-left transition-colors hover:text-landing-red"
                  aria-expanded={isOpen}
                >
                  <span className="font-display text-[16px] font-semibold text-landing-text group-hover:text-landing-red md:text-[18px]">
                    {item.q}
                  </span>
                  <ChevronDown
                    className={cn(
                      "h-5 w-5 shrink-0 text-landing-muted transition-transform duration-300",
                      isOpen && "rotate-180 text-landing-red",
                    )}
                  />
                </button>
                <div
                  className={cn(
                    "overflow-hidden transition-all duration-300",
                    isOpen ? "max-h-60 pb-5" : "max-h-0",
                  )}
                >
                  <p className="text-[15px] leading-relaxed text-landing-muted">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* "Ver todas las preguntas" (/faq) oculto para el lanzamiento — la home ES el FAQ.
        <div className="mt-8 text-center">
                  <Link
                    to="/faq"
                    className="inline-flex items-center gap-1.5 text-[14px] font-semibold text-landing-red underline decoration-landing-red/30 underline-offset-4 transition-colors hover:decoration-landing-red"
                  >
                    {t("landing.home.faq.viewAll")}
                    <ChevronRight className="h-4 w-4" />
                  </Link>
                </div> */}
      </div>
    </section>
  );
}
